export default [{
  path: 'scfv',
  component: require('./Read').default,
  meta: { middleware: 'auth', controller: 'ScfvController' }
},
{
  path: 'scfv/edit/:id',
  component: require('./Edit').default,
  meta: { middleware: 'auth', controller: 'ScfvController' },
},
{
  path: 'scfv/show/:id',
  component: require('./Show').default,
  meta: {
    middleware: 'auth',
    controller: 'ScfvController'
  }
},
{
  path: 'scfv/:id/vinculo/:vinculo/edit',
  component: require('./includes/abas/usuariosvinculado/Edit').default,
  meta: { middleware: 'auth', controller: 'ScfvVinculoController' },
},
{
  path: 'relatorios/scfv',
  component: require('./reports/Reports').default,
  redirect: 'relatorios/scfv/grupos',
  meta: { middleware: 'auth', controller: 'SituacaoPrioritariaController' },
  children: [{
    path: 'home',
    name: 'graficos_scfv',
    component: require('./reports/includes/Home').default,
    meta: { middleware: 'auth', controller: 'SituacaoPrioritariaController' },
  },
  {
    path: 'inscritos',
    name: 'relatorios_inscritos_scfv',
    component: require('./reports/includes/Inscritos').default,
    meta: { middleware: 'auth', controller: 'SituacaoPrioritariaController' },
  },
  {
    path: 'grupos',
    name: 'relatorios_grupos_scfv',
    component: require('./reports/includes/Grupos').default,
    meta: { middleware: 'auth', controller: 'SituacaoPrioritariaController' },
  },
  {
    path: 'participantes/atividades',
    name: 'relatorios_participantes_atividades',
    component: require('./reports/includes/ParticipacaoAtividades').default,
    meta: { middleware: 'auth', controller: 'SituacaoPrioritariaController' },
  },
    // {
    //     path: 'sprioritarias',
    //     component: require('./reports/includes/ReportSituacaoPrioritaria').default,
    //     meta: { middleware: 'auth', controller: 'ScfvController' },
    // },
  ]
}
];
